import { useSearchParams } from "react-router-dom";
import BoothScreen from "modules/shelter/components/BoothScreen";
import BoothsScreenHeader from "modules/shelter/components/BoothScreen/BoothScreenHeader";
import Card from "modules/Core/sub-modules/ui-kit/components/Card";
import Container from "modules/Core/sub-modules/ui-kit/components/Container";
import ExpandableCard from "modules/Core/sub-modules/ui-kit/components/Card/ExpandableCard";
import SubscriptionPanel from "modules/membership/components/SubscriptionPanel";
import AccountTab from "./AccountTab";
import styles from "./styles.module.scss";

const AccountSettingsScreen = () => {
    const [searchParams] = useSearchParams();
    const subscriptionOpen = searchParams.get("tab") === "subscription";

    return (
        <BoothScreen header="Settings">
            <BoothsScreenHeader header="Settings" />
            <Container className={styles.content} flex col>
                <Card className={styles.card} header="Account">
                    <AccountTab />
                </Card>
                <ExpandableCard
                    className={styles.subscriptionCard}
                    title="Subscription"
                    defaultOpen={subscriptionOpen}
                >
                    <SubscriptionPanel />
                </ExpandableCard>
            </Container>
        </BoothScreen>
    );
};

export default AccountSettingsScreen;
